var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","data-test":"course-leaders"}},[_c('portal',{attrs:{"to":"toolbar"}},[_c('v-toolbar-title',[_vm._v("Course Leaders")])],1),_c('v-card',[_c('courseLeadersList',{attrs:{"list":_vm.list,"loading":_vm.loading},on:{"reload-list":_vm.loadList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }